import { API_BASE_URL } from "../config/apiBaseUrl.js";

function buildWeatherApiUrl(path) {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${API_BASE_URL}${normalized}`;
}

const BASE = "/api/weather/radar/siata-santa-elena/archive";

export async function fetchSiataSantaElenaArchiveSummary() {
  const response = await fetch(buildWeatherApiUrl(`${BASE}/summary`));
  if (!response.ok) {
    throw new Error(`SIATA archive summary unavailable (${response.status})`);
  }
  return response.json();
}

export async function fetchSiataSantaElenaArchiveReplay({ start, end, limit } = {}) {
  const params = new URLSearchParams();
  if (start) params.set("start", start);
  if (end) params.set("end", end);
  if (limit) params.set("limit", String(limit));

  const query = params.toString();
  const response = await fetch(buildWeatherApiUrl(`${BASE}/replay${query ? `?${query}` : ""}`));
  if (!response.ok) {
    throw new Error(`SIATA archive replay unavailable (${response.status})`);
  }
  return response.json();
}

export async function fetchSiataSantaElenaArchiveIncidents() {
  const response = await fetch(
    buildWeatherApiUrl("/api/admin/weather/radar/siata-santa-elena/incidents")
  );
  if (!response.ok) {
    throw new Error(`SIATA archive incidents unavailable (${response.status})`);
  }
  return response.json();
}

export async function createSiataSantaElenaArchiveIncident(body) {
  const response = await fetch(
    buildWeatherApiUrl("/api/admin/weather/radar/siata-santa-elena/incidents"),
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    }
  );
  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    throw new Error(payload.message || `Unable to create incident (${response.status})`);
  }
  return response.json();
}

export function resolveSiataArchiveFrameAbsoluteUrl(frame) {
  if (!frame) {
    return null;
  }

  const url = frame.publicUrl || frame.archiveUrl;
  if (!url) {
    return null;
  }

  if (/^https?:\/\//i.test(url)) {
    return url;
  }

  return buildWeatherApiUrl(url);
}
